




















import Vue from 'vue'
import AddPermission from './AddPermission.vue'
import {MasterlinkApiScopeServiceProxy, MenuScopeApiItemDto, AppCardServiceProxy, AppCardScopeServiceProxy} from '@/service-proxies/app-v2/system.service-proxies'

const serviceProxy = new AppCardServiceProxy()
const apiScopeService = new MasterlinkApiScopeServiceProxy()
const appCardScopeServiceProxy = new AppCardScopeServiceProxy()
const columns = [
  {
    title: '',
    dataIndex: 'operation',
    scopedSlots: {customRender: 'operation'},
    width: '30px'
  },
  {
    title: '权限名称',
    dataIndex: 'scopeName'
  },
  {
    title: '权限编号',
    dataIndex: 'resourceCode',
    scopedSlots: {customRender: 'icon'},
    width: '200px'
  },
  {
    title: '接口方法',
    dataIndex: 'httpMethod'
  },
  {
    title: '接口路径',
    dataIndex: 'scopePath',
    width: '256px'
  },
];

export default Vue.extend({
  components: {
    AddPermission
  },
  props: {
    cardInfo: {
      type: Object
    }
  },
  data() {
    return {
      data: [],
      columns,
      addPerimissionVisible: false
    }
  },
  watch: {
    'cardInfo.id': {
      handler(val) {
        this.data = []
        if (val) {
          this.getScopeList()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getScopeList() { // 查询权限列表
      appCardScopeServiceProxy.getScopeList(this.cardInfo.id, '', '').then((res: any) => {
        // console.log('接口列表:', res)
        if (res) {
          this.data = res
          this.data.map((item: any, i: any) => item.key = i)
          this.data = [...this.data]
        }
      })
    },
    addPermission() {
      this.addPerimissionVisible = true
    },
    close(reload?: boolean) {
      this.addPerimissionVisible = false
      if (reload) {
        this.getScopeList()
      }
    },
    deletePermission(record: any) {
      appCardScopeServiceProxy.removePermission(record.id).then((res: any) => {
        if (res) {
          this.$message.success("删除成功！")
          this.getScopeList()
        }
      }, (err: any) => {
        this.$message.error("删除失败！")
      })
    }
  }
})
